import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(false);
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [state, setState] = useAggregatedState({
        table: null
    });

    const apiClient = useContext(RestApiContext);

    const getTableAsync = async (tableId, withUsers) => {
        try {
            const table = await apiClient.getManagedTableAsync(tableId, withUsers);
            setState({ table });    
        } catch(e) {
            console.debug(e);
        }
    }

    const searchUsersAsync = async (userFullPartialName) => {
        try {
            const users = await apiClient.getGraphUsersAsync(userFullPartialName);
            return users;    
        } catch(e) {
            console.debug(e);
        }
    }

    const addUserToTableAsync = async ({tableId, userId, roleIds }) => {
        try {
            await apiClient.addRolesToUserAsync({ roleIds, userId, tableId });
            const table = await apiClient.getManagedTableAsync(tableId, true );
            setState({ table });
        } catch(e) {
            console.debug(e);
        }
    }    

    const removeUserFromTableAsync = async (tableId, userId) => {
        try {
            await apiClient.revokeAllRolesForUserAsync(userId, [tableId]);
            const table = await apiClient.getManagedTableAsync(tableId, true);
            setState({ table });    
        } catch(e) {
            console.debug(e);
        }
    }

    const addRoleToUserAsync = async ({ roleId , userId, tableId }) => {
        try {
            await apiClient.addRoleToUserAsync({ roleId , userId, tableId });
            const table = await apiClient.getManagedTableAsync(tableId, true);
            setState({ table });    
        } catch(e) {
            console.debug(e);
        }
    }

    const removeRoleForUserAsync = async (roleId, userId, tableId) => {
        try {
            await apiClient.revokeRoleForUserAsync(roleId , userId, [tableId]);
            const table = await apiClient.getManagedTableAsync(tableId, true);
            setState({ table });    
        } catch(e) {
            console.debug(e);
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getTableAsync,
            searchUsersAsync,
            addUserToTableAsync,            
            removeUserFromTableAsync,
            addRoleToUserAsync,
            removeRoleForUserAsync
        }}>
            {props.children}
        </Provider>
    );
}
